import { createSlice } from "@reduxjs/toolkit";

export const initialState = {
  error: "",
  success: "",
  user: {},
  userProfile: null as any,
  loading: false,
};

const ProfileSlice = createSlice({
  name: "Profile",
  initialState,
  reducers: {
    profileSuccess(state, action) {
      state.success = action.payload.status;
      state.user = action.payload.data
    },
    profileError(state, action) {
      state.error = action.payload
    },
    editProfileChange(state) {
      state = { ...state };
    },
    resetProfileFlagChange(state) {
      state.success = ""
    },
    setUserProfile(state, action) {
      state.userProfile = action.payload;
      state.loading = false;
      state.error = "";
    },
    setProfileLoading(state, action) {
      state.loading = action.payload;
    },
  },
});

export const {
  profileSuccess,
  profileError,
  editProfileChange,
  resetProfileFlagChange,
  setUserProfile,
  setProfileLoading,
} = ProfileSlice.actions

export default ProfileSlice.reducer;